import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AvisoRestaurante, Restaurant } from '../models/dto/restaurant';
import { CartaMenu } from '../models/dto/carta-menu';
import { MenuLanguageResolution } from '../models/menu-language';

@Injectable({
  providedIn: 'root'
})
export class RestaurantService {

  private readonly urlApi = environment.url_api;
  private readonly urlApiV2 = environment.url_api_v2;

  constructor(private http: HttpClient) { }

  //#region Services v2
  getRestaurantsv2(): Observable<Array<Restaurant>> {
    let urlRegistro = this.urlApiV2 + 'api/v2/restaurantes';
    return this.http.get<Array<Restaurant>>(urlRegistro);
  }

  getAvisoRestaurantev2(idComercio: number, language: string = 'es'): Observable<any> {
    const urlRegistro = this.urlApiV2 + 'api/v2/restaurantes/' + idComercio + '/aviso';
    const params = new HttpParams().set('language', language);
    return this.http.get<AvisoRestaurante>(urlRegistro, { params });
  }
  //#endregion
  getRestaurants(): Observable<Array<Restaurant>> {
    let urlRegistro = this.urlApi + 'Restaurant/0';
    return this.http.get<Array<Restaurant>>(urlRegistro);
  }

  getDetailRestaurants(idRestaurant: number): Observable<Restaurant> {
    let urlRegistro = this.urlApi + 'DetalleRestaurant/' + idRestaurant;
    return this.http.get<Restaurant>(urlRegistro);
  }

  getMenu(idRestaurant: number, idMenu: number, language: string): Observable<Array<CartaMenu>> {
    let urlRegistro = this.urlApi + 'CartaMenu/' + idRestaurant + "/" + language + "/" + idMenu;

    return this.http.get<Array<CartaMenu>>(urlRegistro);
  }

  getCualidades() {
    let urlRegistro = this.urlApi + "/ListaCualidades";

    const headers = { 'Content-Type': 'application/json' };
    return this.http.get(urlRegistro);
  }


  getUnidades() {
    let urlRegistro = this.urlApi + "/ListaUnidades";

    const headers = { 'Content-Type': 'application/json' };
    return this.http.get(urlRegistro);
  }


  // Resuelve el idCarta correspondiente a un idioma destino a partir del idCarta original
  // (ES, el de la URL/QR), usando el endpoint público de resolución del backend
  // (FormatoCatalogo.IdCatalogo como identidad lógica compartida entre idiomas).
  // No requiere JWT y NO descarga listas completas de cartas.
  resolveCartaLanguagev2(idCarta: number, language: string) {
    let urlRegistro = this.urlApiV2 + "api/v2/cartas/" + idCarta + "/language/" + language;

    return this.http.get<MenuLanguageResolution>(urlRegistro);
  }

  //V2
  getMenuV2(idRestaurant: number, idMenu: number, language: string, option: number) {
    let urlRegistro = this.urlApiV2 + "api/v2/cartas/cliente/" + idRestaurant + "/" + idMenu + "/" + language + "/" + option;

    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<any>(urlRegistro);
  }
  ObtienePlatosPorSeccionv2(idComercio: number, idSeccion: number) {
    let urlRegistro = this.urlApiV2 + 'api/v2/cartas/detalles/productos/' + idComercio + "/" + idSeccion;

    const headers = { 'Content-Type': 'application/json' };
    return this.http.get(urlRegistro, { headers });
  }

  getSucursalGeoreferneciadav2(input:any) {
    let urlRegistro = this.urlApiV2 + "api/v2/sucursales/georeferenciadas";

    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any>(urlRegistro, input);
  }
}
